import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import { Offer } from 'app/modules/main/models/offers';
import { OffersState } from 'app/modules/communication-centre/advertiser/store/offers/offers.state';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class OffersSelectors {

  static readonly FEATURE = 'Offers';

  private readonly feature = createFeatureSelector<OffersState>(
    OffersSelectors.FEATURE
  );

  private readonly offers = createSelector(
    this.feature,
    (state: OffersState) => state.offers
  );

  private readonly offersLoaded = createSelector(
    this.feature,
    (state: OffersState) => state.offersLoaded
  );

  constructor(
    private readonly store: Store<OffersState>
  ) {
  }

  public haveOffersLoaded(): Observable<boolean> {
    return this.store.select(this.offersLoaded);
  }

  public onOffersLoaded(): Observable<boolean> {

    return this.haveOffersLoaded()
      .pipe(filter(x => !!x));
  }

  public getOffers(): Observable<Offer[]> {

    return this.onOffersLoaded()
      .pipe(switchMap(() => this.store.select(this.offers)));
  }

}
